import { AfterViewInit, Component, inject, ViewChild } from '@angular/core';
import { map, Observable } from 'rxjs';
import { SessionService } from 'src/app/auth/session.service';
import AppSettings from 'src/app/common/app.settings';
import { FileContext } from 'src/app/interfaces/file.interface';
import { Session } from 'src/app/interfaces/session.interface';
import { MaybeNull } from 'src/app/utils';
import { FormFieldSate } from '../../form-field.state';
import { FileFormFieldComponent } from '../file-form-field/file-form-field.component';

@Component({
  selector: 'app-photo-form-field',
  templateUrl: './photo-form-field.component.html',
  styleUrls: ['./photo-form-field.component.scss'],
})
export class PhotoFormFieldComponent extends FormFieldSate implements FileContext, AfterViewInit {
  public element: MaybeNull<HTMLElement> = null;
  public photoLink = AppSettings.NO_PHOTO_DEFAULT_IMAGE;
  public AppSettings: typeof AppSettings = AppSettings;

  @ViewChild(FileFormFieldComponent, { static: false }) public fileComponent: FileFormFieldComponent;

  public readonly adminSession$: Observable<boolean> = inject(SessionService).sessionChanges.pipe(
    map((session: Session) => session.adminSession),
  );

  public ngAfterViewInit(): void {
    this.element = document.getElementById(this.fieldAttribute.backendAttribute.name);

    this.updateFile(this.control.value as string);
  }

  public updateFile(link: string): void {
    this.photoLink = link;
  }

  public delete(): void {
    this.updateFile('');
    this.fileComponent.deleteAssociation();
  }

  public onError(): void {
    this.formStateService.validateControl(this.control);
    this.control.setErrors({ notRequiredPhotoType: true });

    setTimeout(() => this.control.setErrors(null), 5000);
  }
}
